// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null,
  data2: [],
  total2: 1,
  from2: 0,
  t2o: 0,
  params2: {},
}

const proposals = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_DATA2':
      return {
        ...state,
        data2: action.data,
        total2: action.totalPages,
        params2: action.params,
        from2: action.from,
        to2: action.to,
      }
    case 'SHOW':
      return { ...state, selectedData: action.selectedData }
    case 'ADD':
      return { ...state }
    case 'EDIT':
      return { ...state }
    case 'DELETE':
      return { ...state }
    default:
      return { ...state }
  }
}
export default proposals
